import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

/**
 * InstanceLoader - A loader component for WebViewer instance initialization
 * 
 * Unlike the full-page Loader, this loader:
 * - Only covers the document content area (not the sidebar)
 * - Is positioned below the breadcrumbs
 * - Allows users to interact with sidebar and other UI elements
 */
const InstanceLoader = ({ message }) => {
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      zIndex: 15, // Lower than breadcrumb header (zIndex: 20) so breadcrumbs stay visible on top
      pointerEvents: 'auto',
      // Ensure breadcrumb area is not covered - the breadcrumb header will render on top due to higher z-index
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        marginTop: '80px', // Push loader content down to appear below breadcrumbs
      }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#0C53BB' }} spin />} />
        <span style={{
          fontSize: '14px',
          color: '#5A6C87',
          textAlign: 'center',
        }}>
          {message || "Loading WebViewer..."}
        </span>
      </div>
    </div>
  );
};

InstanceLoader.propTypes = {
  message: PropTypes.string
};

export default InstanceLoader;
